export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-apple-7ca78da8eef2b44c44bfe929b86f9aa7.svg";